import React, { useEffect, useState } from "react";

const API = "https://api.haymestasarim.com/api";

export default function EkibimPage() {
  const token = localStorage.getItem("user_token");

const [profile, setProfile] = useState(null);
const [loading, setLoading] = useState(true);
const [members, setMembers] = useState([]);
const [refCode, setRefCode] = useState("");

useEffect(() => {
  if (!token) return;

fetch(`${API}/auth/my-ref`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => setRefCode(d.ref_code || ""))
    .catch(() => setRefCode(""));
}, [token]);


useEffect(() => {
  if (!token) return;

fetch(`${API}/network/team`, {
  headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => {
      setProfile(d);
      setLoading(false);
    })
    .catch(() => setLoading(false));
}, [token]);



useEffect(() => {
  if (!token) return;

fetch(`${API}/network/team/members`, {
  headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => setMembers(Array.isArray(d) ? d : []))
    .catch(() => setMembers([]));
}, [token]);



if (loading) {
  return <div style={styles.loading}>Yükleniyor...</div>;
}

const user = profile?.me || {
  role: "Kullanıcı",
  location: {
    country: "",
    city_name: "",
    district_name: ""
  }
};

const cityName = user.location.city_name || "—";
const districtName = user.location.district_name || "—";

const team = profile?.team || { total: 0, direct: 0 };
const targets = profile?.targets || {};

// 🔹 ALT KULLANICI RESET KURALI
const hasAnyTeam = team?.total > 0;

// 🔥 PROGRESS İÇİN GERÇEK DEĞERLER
const cityDoneForProgress = hasAnyTeam
  ? targets?.city?.activeDistricts || 0
  : 0;

const cityTotalForProgress =
  targets?.city?.totalDistricts || 1;

// 🔹 ÜLKE İÇİN GERÇEK AKTİF İL SAYISI (members fallback)
const uniqueCities = hasAnyTeam
  ? Array.from(
      new Set(
        members
          .map(m => m.il)
          .filter(Boolean)
      )
    )
  : [];

const countryDoneForProgress = hasAnyTeam
  ? (
      targets?.country?.activeCities > 0
        ? targets.country.activeCities
        : uniqueCities.length
    )
  : 0;


const countryTotalForProgress = 81;

// 🔹 SADECE BU İLÇEDEKİ KİŞİLER
const sameDistrictMembers = hasAnyTeam
  ? members.filter(m => m.ilce === districtName)
  : [];

// 🔹 İLÇEDEKİ TOPLAM ÜYE SAYISI
// Kim davet etmiş, kimin altı üstü UMURSANMAZ
const myDistrictCount = sameDistrictMembers.length;

// 🔹 İLÇE LİDERLİĞİ KURALI
// 0 kişi → lider yok
// 1 ve üzeri → liderlik var
const isDistrictLeader = myDistrictCount > 0;




  return (
    <div style={styles.page}>
<h2 style={styles.title}>Ekibim & Kademe Durumum</h2>
<p style={styles.subtitle}>
  Referans ağınızı büyüterek 4 kademe derinlikte kazanç elde edin. 
  Ekibiniz genişledikçe sistem otomatik olarak kazanç üretir.
</p>



      {/* KONUM & KOD */}
      <div style={styles.topGrid}>

<InfoBox
  title="Bulunduğunuz Bölge"
  value={[
    user.location.country || "—",
    cityName,
    districtName,
  ].join(" / ")}
/>

<InfoBox
  title="Referans Kodunuz"
  value={refCode || "—"}
  highlight
/>
      </div>

      {/* LİDERLİK DURUMU */}
      <div style={styles.levelBox}>
        <h3 style={styles.sectionTitle}>Mevcut Seviyeniz</h3>

        <div style={styles.levelGrid}>
    
<LevelCard
  active={true}
  title="1. Kademe"
  percent="%15 Kazanç"
  desc="Doğrudan referansınızla sisteme katılan her aktif kullanıcıdan %15 oranında kazanç elde edersiniz."
/>

<LevelCard
  active={true}
  title="2. Kademe"
  percent="%10 Kazanç"
  desc="1. kademenizdeki kullanıcıların referanslarından oluşan 2. seviyeden %10 oranında kazanç sağlarsınız."
/>

<LevelCard
  active={true}
  title="3. Kademe"
  percent="%5 Kazanç"
  desc="Ağınız 3. seviyeye ulaştığında, bu derinlikten %5 oranında gelir elde edersiniz."
/>

<LevelCard
  active={true}
  title="4. Kademe"
  percent="%2 Kazanç"
  desc="4. derinliğe kadar oluşan ekipten %2 oranında pasif kazanç sağlarsınız."
/>





</div> 

      {/* NASIL YÜKSELİRİM */}
      <div style={styles.howBox}>
        <h3 style={styles.sectionTitle}>Nasıl Yükselirim?</h3>

        <div style={styles.howGrid}>
          
<HowCard
  title="1. Kademe Kazancı"
  text="Doğrudan davet ettiğiniz her aktif kullanıcı, 1. kademenizi oluşturur ve bu seviyeden %15 oranında kazanç elde edersiniz."
  color="#f59e0b"
/>

<HowCard
  title="Derinlik Oluşturma"
  text="Referanslarınızın da yeni kullanıcılar davet etmesiyle ağınız 2., 3. ve 4. seviyeye kadar genişler."
  color="#2563eb"
/>

<HowCard
  title="Pasif Gelir Mantığı"
  text="4. kademeye kadar oluşan tüm satışlardan otomatik olarak gelir kazanırsınız. Sistem derinlik bazlı çalışır."
  color="#6366f1"
/>


        </div>
      </div>
</div> 

{/* EKİBİM LİSTESİ */}


      {/* MOTİVASYON */}
    <div
  style={{
    ...styles.motivation,
    background:
      "linear-gradient(135deg, #f97316, #2563eb)",
  }}
>
  <h3
    style={{
      fontSize: 28,
      fontWeight: 900,
      marginBottom: 12,
      textTransform: "uppercase",
      letterSpacing: 1,
    }}
  >
    🚀 AĞINIZI BÜYÜTÜN, KAZANCINIZI ARTIRIN
  </h3>

  <p
    style={{
      fontSize: 18,
      fontWeight: 600,
      lineHeight: 1.5,
      maxWidth: 720,
      margin: "0 auto",
    }}
  >
    Referans kodunuzu paylaşarak ekibinizi genişletin.  
    <br />
    Her yeni <strong>aktif üye</strong> sizi bir üst liderlik seviyesine taşır.
  </p>
</div>



{/* AĞ PERFORMANSI */}
<div style={{ marginTop: 40 }}>
  <h3 style={styles.sectionTitle}>Ağ Performansınız</h3>

  <div style={styles.progressGrid}>

    {/* TOPLAM ÜYE */}
    <div style={styles.progressCard}>
      <h4>Toplam Üye</h4>
    <div style={{ fontSize: 28, fontWeight: 800, marginTop: 10 }}>
  <AnimatedNumber value={team?.total || 0} />
</div>

      <p style={{ marginTop: 8, color: "#64748b" }}>
Toplam Bayi Sayınız
      </p>
    </div>

    {/* 1. KADEME */}
    <div style={styles.progressCard}>
      <h4>1. Kademe</h4>
    <div style={{ fontSize: 26, fontWeight: 800 }}>
  <AnimatedNumber value={members.filter(m => m.level === 1).length} />
</div>
      <p style={{ color: "#64748b" }}>
        Doğrudan referanslarınız
      </p>
    </div>

    {/* 2. KADEME */}
    <div style={styles.progressCard}>
      <h4>2. Kademe</h4>
      <div style={{ fontSize: 26, fontWeight: 800 }}>
  <AnimatedNumber value={members.filter(m => m.level === 2).length} />
</div>

      <p style={{ color: "#64748b" }}>
        1. kademenizin referansları
      </p>
    </div>

    {/* 3. KADEME */}
    <div style={styles.progressCard}>
      <h4>3. Kademe</h4>
      <div style={{ fontSize: 26, fontWeight: 800 }}>
  <AnimatedNumber value={members.filter(m => m.level === 3).length} />
</div>

      <p style={{ color: "#64748b" }}>
        3. seviye derinlik
      </p>
    </div>

    {/* 4. KADEME */}
    <div style={styles.progressCard}>
      <h4>4. Kademe</h4>
    <div style={{ fontSize: 26, fontWeight: 800 }}>
  <AnimatedNumber value={members.filter(m => m.level === 4).length} />
</div>

      <p style={{ color: "#64748b" }}>
        4. seviye pasif kazanç
      </p>
    </div>

  </div>
</div>




      {/* REFERANSLARIM */}
      <div style={{ marginTop: 40 }}>
        <h3 style={styles.sectionTitle}>Referansımla Katılanlar</h3>

        {members.length === 0 ? (
          <div style={styles.emptyBox}>
            Henüz referansınızla katılan kullanıcı yok.
          </div>
        ) : (
          <div style={styles.memberGrid}>
            {members.map((m) => (
  <div key={m.id} style={styles.memberCard}>
    <div style={styles.memberEmail}>{m.email}</div>

    <div style={styles.memberLocation}>
      {m.il || "—"} / {m.ilce || "—"}
    </div>

    <div style={styles.memberLevel}>
      Seviye: {m.level}. Kademe
    </div>

    {m.counts_for_district && (
      <div style={styles.badgeDistrict}>
        İlçe Bayiliğine Sayılır
      </div>
    )}

    {m.counts_for_city && !m.counts_for_district && (
      <div style={styles.badgeCity}>
        İl Bayiliğine Sayılır
      </div>
    )}

    {m.bonus_only && (
      <div style={styles.badgeBonus}>
        Sadece Bonus Kazandırır
      </div>
    )}
  </div>
))}


          </div>
        )}
      </div>

    </div>
  );
}



/* ================= COMPONENTS ================= */

function AnimatedNumber({ value, duration = 800 }) {
  const [displayValue, setDisplayValue] = React.useState(0);

  React.useEffect(() => {
    let start = 0;
    const increment = value / (duration / 16);

    const counter = setInterval(() => {
      start += increment;
      if (start >= value) {
        setDisplayValue(value);
        clearInterval(counter);
      } else {
        setDisplayValue(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(counter);
  }, [value, duration]);

  return <>{displayValue}</>;
}


function InfoBox({ title, value, highlight }) {
  return (
    <div
      style={{
        ...styles.infoBox,
        background: highlight ? "#eef2ff" : "#fff",
        borderColor: highlight ? "#6366f1" : "#e5e7eb",
      }}
    >
      <div style={styles.infoTitle}>{title}</div>
      <div style={styles.infoValue}>{value}</div>
    </div>
  );
}

function LevelCard({ title, percent, desc, active }) {
  return (
    <div
      style={{
        ...styles.levelCard,
        borderColor: active ? "#2563eb" : "#e5e7eb",
        background: active ? "#eff6ff" : "#fff",
      }}
    >
      <h4>{title}</h4>
      <div style={styles.levelPercent}>{percent}</div>
      <p>{desc}</p>
      {active && <span style={styles.activeBadge}>AKTİF</span>}
    </div>
  );
}

function HowCard({ title, text, color }) {
  return (
    <div style={{ ...styles.howCard, borderTop: `4px solid ${color}` }}>
      <h4>{title}</h4>
      <p>{text}</p>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  page: { padding: 32 },
  title: { fontSize: 26, fontWeight: 800 },
  subtitle: { color: "#64748b", marginBottom: 24 },

  loading: { padding: 40, textAlign: "center" },

  topGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
    gap: 16,
    marginBottom: 30,
  },

  infoBox: {
    padding: 20,
    borderRadius: 16,
    border: "1px solid",
    boxShadow: "0 10px 25px rgba(0,0,0,.06)",
  },
  infoTitle: { fontSize: 14, color: "#64748b" },
  infoValue: { fontSize: 20, fontWeight: 800 },

  levelBox: { marginBottom: 40 },
  sectionTitle: { fontSize: 20, fontWeight: 700, marginBottom: 16 },

  levelGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
    gap: 16,
  },

  levelCard: {
    padding: 20,
    borderRadius: 18,
    border: "1px solid",
    position: "relative",
    boxShadow: "0 10px 25px rgba(0,0,0,.06)",
  },
  levelPercent: { fontSize: 22, fontWeight: 800, margin: "10px 0" },
  activeBadge: {
    position: "absolute",
    top: 14,
    right: 14,
    background: "#2563eb",
    color: "#fff",
    padding: "4px 10px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 700,
  },

  howBox: { marginBottom: 40 },
  howGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
    gap: 16,
  },
  howCard: {
    background: "#fff",
    padding: 20,
    borderRadius: 16,
    boxShadow: "0 10px 25px rgba(0,0,0,.06)",
  },

  motivation: {
    background: "linear-gradient(135deg,#2563eb,#6366f1)",
    color: "#fff",
    padding: 30,
    borderRadius: 20,
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,.15)",
  },

th: {
  padding: 12,
  textAlign: "left",
  fontWeight: 700,
  fontSize: 14,
  color: "#334155",
},

td: {
  padding: 12,
  fontSize: 14,
  color: "#334155",
},


emptyBox: {
  background: "#fff",
  padding: 30,
  borderRadius: 16,
  textAlign: "center",
  boxShadow: "0 10px 25px rgba(0,0,0,.05)",
  color: "#475569",
},


memberGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: 16,
},

memberCard: {
  background: "#fff",
  padding: 18,
  borderRadius: 16,
  boxShadow: "0 10px 25px rgba(0,0,0,.08)",
  border: "1px solid #e5e7eb",
},

memberEmail: {
  fontSize: 15,
  fontWeight: 700,
  marginBottom: 6,
},

memberLocation: {
  fontSize: 14,
  color: "#475569",
},

memberLevel: {
  marginTop: 8,
  fontSize: 13,
  color: "#2563eb",
  fontWeight: 600,
},


badgeDistrict: {
  marginTop: 8,
  padding: "4px 10px",
  background: "#f59e0b",
  color: "#fff",
  borderRadius: 12,
  fontSize: 12,
  fontWeight: 700,
  display: "inline-block",
},

badgeCity: {
  marginTop: 8,
  padding: "4px 10px",
  background: "#10b981",
  color: "#fff",
  borderRadius: 12,
  fontSize: 12,
  fontWeight: 700,
  display: "inline-block",
},

badgeBonus: {
  marginTop: 8,
  padding: "4px 10px",
  background: "#64748b",
  color: "#fff",
  borderRadius: 12,
  fontSize: 12,
  fontWeight: 700,
  display: "inline-block",
},

progressGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 20,
},


remaining: {
  marginTop: 6,
  display: "inline-block",
  fontSize: 13,
  color: "#ef4444",
  fontWeight: 600,
},


progressCard: {
  background: "#fff",
  borderRadius: 20,
  padding: 24,
  textAlign: "center",
  boxShadow: "0 15px 35px rgba(0,0,0,.08)",
  transition: "all .2s ease",
  border: "1px solid #f1f5f9"
},






};

/* =====================================================
   MOBILE RESPONSIVE OVERRIDE
===================================================== */

if (typeof window !== "undefined") {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    styles.page.padding = 16;

    styles.topGrid.gridTemplateColumns = "1fr";
    styles.levelGrid.gridTemplateColumns = "1fr";
    styles.howGrid.gridTemplateColumns = "1fr";
    styles.memberGrid.gridTemplateColumns = "1fr";
    styles.progressGrid.gridTemplateColumns = "1fr";

    styles.title.fontSize = 22;

    styles.progressCard.padding = 18;
    styles.levelCard.padding = 18;
    styles.memberCard.padding = 16;
  }
}


